import dayjs from 'dayjs'
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../constants/dates.constants'

export const formatDateString = (dateString: string): string => {
  if (!dateString) {
    return 'N/A'
  }
  return dayjs(dateString).format(DATE_FORMAT)
}

export const formatDateTimeString = (dateString: string): string => {
  if (!dateString) {
    return 'N/A'
  }
  return dayjs(dateString).format(DATE_TIME_FORMAT)
}

export const formatTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60)
  const secs = Math.floor(seconds % 60)
  return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
}
